import dayjs, { Dayjs } from "dayjs";

export interface CalendarDay {
    date: Dayjs;
    isCurrentMonth: boolean;
    isToday: boolean;
    dayNumber: number;
}

export function generateCalendarDays(month: Dayjs): CalendarDay[] {
    const startOfMonth = month.startOf("month");
    const endOfMonth = month.endOf("month");
    const startOfCalendar = startOfMonth.startOf("week");
    const endOfCalendar = endOfMonth.endOf("week");

    const days: CalendarDay[] = [];
    let currentDay = startOfCalendar;
    const today = dayjs().startOf("day");

    while (currentDay.isBefore(endOfCalendar) || currentDay.isSame(endOfCalendar, "day")) {
        days.push({
            date: currentDay,
            isCurrentMonth: currentDay.isSame(month, "month"),
            isToday: currentDay.isSame(today, "day"),
            dayNumber: currentDay.date(),
        });
        currentDay = currentDay.add(1, "day");
    }

    return days;
}

export function getEntryForDate(
    entries: Array<{ created_at: string; entry_id: string; submitted_at: string | null }>,
    date: Dayjs
): { entry_id: string; submitted_at: string | null } | undefined {
    return entries.find((entry) => {
        const entryDate = dayjs(entry.created_at).startOf("day");
        return entryDate.isSame(date, "day");
    });
}
